<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.webpage_heading" [ttModel]="setting.webpage_heading"></tt-page-heading>

    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-button-goto ttText="checklistitemtws_new" ttGoto="checklistitemtw" [ttGotoParms]="{ argtype: setting.argtype, argvalue: setting.argvalue, checklistitemtw_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list class="col-xs-12 col-md-4 sp-0" [ttData]="itemsListLinksToForms"></tt-list>
</tt-page>
